import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMetrikaConfig } from '@/components/analytics/YandexMetrika.config';

export const useMetrikaPageView = (): void => {
    const location = useLocation();

    useEffect(() => {
        const { enabled, id } = getMetrikaConfig();
        if (!enabled || !id || !window.ym) {
            return;
        }

        window.ym(Number(id), 'hit', location.pathname + location.search);
    }, [location]);
};
